import { createFileRoute, Link } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";
import { PageShell } from "@/components/site/PageShell";

export const Route = createFileRoute("/$lang/help")({
  head: ({ params }) => ({
    meta: [
      { title: "Get Help — MadCaptains" },
      { name: "description", content: "If you are in danger right now, or being harassed aboard, these services are run by people who understand what a shipboard crisis feels like." },
      { property: "og:title", content: "Get Help — MadCaptains" },
      { property: "og:description", content: "If you are in danger right now, or being harassed aboard, these services are run by people who understand what a shipboard crisis feels like." },
      { property: "og:url", content: `/${params.lang}/help` },
    ],
    links: [{ rel: "canonical", href: `/${params.lang}/help` }],
  }),
  component: HelpPage,
});

function HelpPage() {
  const { lang, t } = useI18n();
  return (
    <PageShell eyebrow={t.page_help_h1} title={t.page_help_h1} lead={t.page_help_lead}>
      <div className="space-y-10 text-[1.02rem] leading-[1.75]">
        {/* Danger box */}
        <section
          className="rounded-sm border-l-2 p-5"
          style={{
            borderColor: "var(--amber)",
            background: "color-mix(in oklab, var(--amber) 8%, transparent)",
          }}
        >
          <h2 className="font-display text-xl">{t.help_danger_h2}</h2>
          <ul className="mt-4 list-disc space-y-2 pl-5 text-muted-foreground">
            <li className="text-justify">
              {t.help_danger_seafarerhelp.split("seafarerhelp.org")[0]}
              <a
                href="https://seafarerhelp.org"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4"
                style={{ color: "var(--amber)" }}
              >
                seafarerhelp.org
              </a>
            </li>
            <li className="text-justify">
              {t.help_danger_itf.split("itfseafarers.org")[0]}
              <a
                href="https://itfseafarers.org"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4"
                style={{ color: "var(--amber)" }}
              >
                itfseafarers.org
              </a>
            </li>
            <li className="text-justify">{t.help_danger_emergency}</li>
          </ul>
        </section>

        {/* Harassed section */}
        <section>
          <h2 className="font-display text-2xl">{t.help_harassed_h2}</h2>
          <ul className="mt-4 list-disc space-y-2 pl-5 text-muted-foreground">
            <li className="text-justify">{t.help_harassed_doc}</li>
            <li className="text-justify">{t.help_harassed_procedure}</li>
            <li className="text-justify">{t.help_harassed_contact}</li>
            <li className="text-justify">{t.help_harassed_retaliate}</li>
          </ul>
        </section>

        {/* Story section */}
        <section>
          <h2 className="font-display text-2xl">{t.help_story_h2}</h2>
          <p className="mt-3 text-justify text-muted-foreground">{t.help_story_p}</p>
          <p className="mt-3">
            <Link
              to="/$lang/submit"
              params={{ lang }}
              className="underline underline-offset-4"
              style={{ color: "var(--amber)" }}
            >
              {t.nav_submit_cta} →
            </Link>
          </p>
        </section>

        {/* Not alone */}
        <section>
          <h2 className="font-display text-2xl">{t.help_not_alone_h2}</h2>
          <p
            className="mt-3 text-justify rounded-sm border-l-2 p-4 font-display text-lg italic"
            style={{
              borderColor: "var(--amber)",
              background: "color-mix(in oklab, var(--amber) 6%, transparent)",
            }}
          >
            {t.help_not_alone_p}
          </p>
        </section>
      </div>
    </PageShell>
  );
}
